import {Field} from 'redux-form'
import SettingField from 'components/Fields/ReduxForm/SettingField'

class ItemVariantsFields extends React.Component {
  render () {
    const {member, fields} = this.props
    let isHide = fields.length === 1 ? 'hide' : 'show'
    let cssColumn = isHide === 'hide' ? 'col-md-6' : 'col-md-4'
    return (<div className='mk-grouped-input'>
      {isHide !== 'hide' && <div className={`form-group col-md-4`}>
        <Field
          name={`${member}.name`}
          component={SettingField}
          className='form-control'
          placeholder='Name'
        />
      </div>}
      <div className={`form-group ${cssColumn === 'col-md-6' ? 'col-md-6' : 'col-md-4 no-padding'}`}>
        <Field
          name={`${member}.price`}
          component={SettingField}
          placeholder='Price'
          inputClassName='text-right'
          positiveNumberOnly
        />
      </div>
      <div className={`form-group ${cssColumn}`}>
        <Field
          name={`${member}.sku`}
          component='input'
          className='form-control text-align-last-left'
          placeholder='SKU'
        />
      </div>
    </div>)
  }
}

ItemVariantsFields.propTypes = {
  member: React.PropTypes.object
}

export default ItemVariantsFields



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemForm/ItemVariant/ItemVariantsFieldArray/ItemVariantsFields/ItemVariantsFields.js